// Provider half of the api config seam. Mirrors the
// building-manager-api-client pattern. The Context lives in
// ./context.ts and the consumer hook in ./use-config.ts so this
// file only exports a component (keeps Vite Fast Refresh happy).
import { type ReactNode } from "react";
import {
  InrangeAgentsApiConfigContext,
  type InrangeAgentsApiConfig,
} from "./context";

export const InrangeAgentsApiConfigProvider = ({
  config,
  children,
}: {
  config: InrangeAgentsApiConfig;
  children: ReactNode;
}) => (
  <InrangeAgentsApiConfigContext.Provider value={config}>
    {children}
  </InrangeAgentsApiConfigContext.Provider>
);
